import React, { Fragment, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PageHeader from "./components/page-header/PageHeader";
import HTTPRequest from "./components/shared-components/HTTPRequest";
import brandConfig from "./utils/brandConfig";
import getUrlParams from "./utils/getUrlParams";
import { storedProcedure, getAllLiveProducts } from "./utils/storedProceduresConfig";
import PrePopulateOrgDetails from "./components/shared-components/PrePopulateOrgDetails";
import Basket from "./components/basket/Basket";
import Catalog from "./components/catalog/Catalog";
import Confirmation from "./components/confirmation/Confimation";
import ConfirmOrders from "./components/confirmation/ConfirmOrders";
import OrderForm from "./components/order-form/OrderForm";
import Error404 from "./components/shared-components/error-messages/Error404";
import Footer from "./components/shared-components/Footer";
import DoublestruckInternalTools from "./components/ds-tools/DoublestruckInternalTools";
import { sendBasketUpdate, sendPurchase } from "./utils/googleTagManager";
import md5 from "blueimp-md5";
import { summariseOrder } from "./utils/order";
import { submitUserOrder } from "./utils/storedProcedures";
import commaSeperatedToArray from "./utils/commaSeperatedToArray";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AlertMessage from "./components/shared-components/error-messages/AlertMessage";
import MathsSpecial from "./components/catalog/catalog-components/MathsSpecial";
import LanguagesSpecial from "./components/catalog/catalog-components/LanguagesSpecial";

const App = () => {
	const getBrand = () => {
		const urlParams = getUrlParams();
		if (urlParams && urlParams.brand) {
			return brandConfig.find((item) => item.brand === urlParams.brand);
		} else {
			// default to exampro if the param is not set in the URL for Brand
			return brandConfig[1];
		}
	};

	const setFavicon = (img) => {
		let favicon = document.querySelector('link[rel="shortcut icon"]');
		if (!favicon) {
			favicon = document.createElement("link");
			favicon.setAttribute("rel", "shortcut icon");
			document.head.appendChild(favicon);
		}
		favicon.setAttribute("type", "image/png");
		favicon.setAttribute("href", img);
	};

	const setDocumentTitle = (name) => {
		document.title = `${name} - Order ${name} Today`;
	};

	const [urlParam, setUrlParam] = useState([]);
	const [basket, setBasket] = useState([]);
	const [brand, setBrand] = useState(getBrand());
	const [site, setSite] = useState("");
	// const [documentTitle, setDocumentTitle] = useState("");
	const [showBasket, setShowBasket] = useState(false);
	const [subjectMenuOpen, setSubjectMenuOpen] = useState(false);
	const [showSubject, setShowSubject] = useState(false);
	const handleCloseSubject = () => setShowSubject(false);
	const handleShowSubject = () => setShowSubject(true);
	const [navigationStage, setNavigationStage] = useState();
	const [renewal, setRenewal] = useState(false);
	const [formValues, setFormValues] = useState({});
	const [orderTotal, setOrderTotal] = useState("");
	const [orderSubTotal, setOrderSubTotal] = useState();
	const [MD5, setMD5] = useState();
	const [packages, setPackages] = useState([]);
	const [packagesRequestStage, setPackagesRequestStage] = useState(0);
	const [vat, setVat] = useState("");
	const [message, setMessage] = useState("");
	const [userkey, setUserKey] = useState("");
	const [promo_code, setPromo_code] = useState("");
	const [order, setOrder] = useState({
		org: "",
		dfes: "",
		vat: "",
		postcode: "",
		telephone: "",
		fullname: "",
		email: "",
		mailingAddress: "",
		ArrayProducts: [],
		maildespatch: "",
		MD5: "",
		confirmMail: "",
		IP: "",
		UA: "",
		site: "",
		schoolOrder: "",
		country: "",
		financeemail: "",
		job: "",
		agreeTerms: "",
		quantArray: [],
		totalquantArray: "",
		promo_code: "",
		promo_source: "",
	});
	const [freePackage, setFreePackage] = useState(false);
	const [freeMaths, setFreeMaths] = useState(false);
	const [paperPackage, setPaperPackage] = useState(false);
	const [allLiveProducts, setAllLiveProducts] = useState([]);

	useEffect(() => {
		getAllLiveProducts((data) => {
			setAllLiveProducts(data);
		});

		const params = getUrlParams();
		setUrlParam(params);
	}, []);

	useEffect(() => {
		if (urlParam.packages && allLiveProducts.length) {
			//pre populate the basket
			let urlQuantities = urlParam.packageQuantities ? urlParam.packageQuantities.split(",") : [];

			let urlAdditonalUsers = urlParam.additionalUsers ? urlParam.additionalUsers.split(",") : [];

			let p = urlParam.packages.split(",");

			let packages = p
				.map((packageItem) =>
					allLiveProducts.find((item) => (item.packageID === Number(packageItem) ? item : null))
				)
				.map((packageItem, index) => {
					packageItem.additionalUsers = Number(urlAdditonalUsers[index]) || 0;
					packageItem.packageQuantity = Number(urlQuantities[index]) || 1;
					return packageItem;
				});

			setBasket(packages);
		}
	}, [allLiveProducts, urlParam]);

	useEffect(() => {
		setSite(brand);
		isRenewal();
		setFavicon(brand.favicon);
		setUserKey(getUrlParams().uk);
		setDocumentTitle(brand.name);

		window.location.pathname === "/secondary-maths-onscreen" ||
		window.location.pathname === "/gcse-mfl-aqa"
			? setFreePackage(true)
			: setFreePackage(false);
		window.location.pathname === "/secondary-maths-onscreen"
			? setFreeMaths(true)
			: setFreeMaths(false);

		const findFamilyID = (basket, id) => {
			return basket.some((item) => item.familyID === id);
		};
		const familyIDToFind = 15;
		const exists = findFamilyID(basket, familyIDToFind);
		setPaperPackage(exists);
	}, [brand.name, brand.favicon, brand, basket]);

	const updateMainState = (setFunction, setValue) => {
		setFunction(setValue);
	};

	const getPackagesParams = () => {
		const { invoiceType, sites } = getBrand();
		const inv = invoiceType;
		return storedProcedure.getPackages.requestObject({
			inv,
			sites,
		});
	};

	const handleCloseBasket = () => setShowBasket(false);
	const handleShowBasket = () => setShowBasket(true);

	const isRenewal = () => {
		// looks to see if there is a packages param in the URL to set renewal
		// to true in state this can be used to pass to other components
		const urlParams = getUrlParams();
		urlParams.packages ? setRenewal(true) : setRenewal(false);
	};

	const getMD5 = (postcode) => {
		const date = Date.now();
		const MD5 = md5(date + postcode);
		setMD5(MD5);
		return MD5;
	};

	const updateFormValues = (values) => {
		const currentFormValues = { ...formValues };
		const newFormValues = { ...values, ...currentFormValues };
		setFormValues(newFormValues);
	};

	const updateBasket = (packageItem) => {
		const currentBasket = [...basket];
		const addToBasket = currentBasket.map((item) => {
			if (Number(item.packageID) === Number(packageItem.packageID)) {
				item = packageItem;
			}
			return item;
		});
		setBasket(addToBasket);
	};

	const submitOrder = (getFormValues = formValues) => {
		/**
		 *  ! NOTE: Here are some key things you NEED to know:
		 *  1) ArrayProducts is just a list of all the products
		 *  2) quantArray is an array of additonal users it defaults to 0 if you order a
		 * package that does not have any addional users.
		 *  3) totalquantArray is the total number of addional users added together and
		 * multiplied by 10 (this is the current default extra user price)
		 * 4) packageQuantityArray is the number of packages that are being purchased, this is mainly
		 * for the benifit of Optional Tests where you can purchase multiple of the same item, default
		 * should be 1
		 */

		const {
			purchaseOrder,
			centreName,
			dfeNumber,
			vatNumber,
			centreAddress,
			postcode,
			country,
			phone,
			contactName,
			position,
			centreEmail,
			financeEmail,
			referal,
		} = getFormValues;

		const convertedBasket = basket.map((item) => {
			return {
				packageid: item.productID,
				packageprice: item.price,
				extrauserprice: item.extrauserprice,
				extrausercount: item.additionalUsers.toString(),
				additionalpackage: "0",
				packagenumber: item.packageID.toString(),
				pricetype: "",
				packageQuantity: item.packageQuantity.toString(),
				vat: item.vatApplicable,
			};
		});

		const ordertheseJSON = JSON.stringify(convertedBasket);

		const { vat, subtotal } = summariseOrder(basket);

		const order = {
			IP: "",
			UA: "",
			schoolOrder: purchaseOrder,
			org: centreName,
			dfes: dfeNumber,
			vat: vatNumber,
			mailingAddress: centreAddress,
			postcode: postcode,
			country: country,
			telephone: phone,
			fullname: contactName,
			job: position,
			email: centreEmail,
			financeemail: financeEmail,
			dataManagerEmail: "",
			dataManagerName: "", //See #3185, SP will need to be modified.
			ordertheseJSON: ordertheseJSON,
			subtotal: subtotal,
			vattotal: vat,
			userkey: userkey,
			ArrayProducts: basket.map((packageItem) => packageItem.productID).toString(),
			quantArray: basket.map((packageItem) => packageItem.additionalUsers).toString(),
			totalquantArray: basket.reduce(
				(prev, current) => prev + current.additionalUsers * current.extrauserprice,
				0
			),
			packageQuantityArray: basket
				.map((packageItem) => packageItem.packageQuantity || 1)
				.toString(),
			promo_code: promo_code,
			maildespatch: 1,
			MD5: getMD5(postcode),
			confirmMail: 1,
			site: brand.siteIdentifier,
			agreeTerms: 1,
			promo_source: referal,
		};

		return new Promise((resolve, reject) => {
			// if there are items in the basket
			if (basket.length > 0) {
				const submittedOrder = submitUserOrder(order);
				if (submittedOrder) {
					resolve(submittedOrder);
				} else {
					reject(Error("No order results"));
				}
			} else {
				reject(Error("No order results"));
			}
			sendPurchase(order, basket, brand.brand);
		});
	};

	const removePackageFromBasket = (packageItem) => {
		const currentBasket = [...basket];
		const newBasket = currentBasket.filter((item) => item.packageID !== packageItem.packageID);
		setBasket(newBasket);
		sendBasketUpdate(packageItem, "remove_from_cart", brand.brand);
	};

	const addToBasket = (subjectPackage) => {
		const itemInBasket = basket.find((item) => subjectPackage.packageID === item.packageID);
		// Only add item to basket if not already present
		if (!itemInBasket) {
			let currentBasket = [...basket];
			setBasket([subjectPackage, ...currentBasket]);
		}
		sendBasketUpdate(subjectPackage, "add_to_cart", brand.brand);
	};

	const addMultipleItemsToBasket = (packagesArray) => {
		let currentBasket = [...basket];
		const getBasket = [...packagesArray, ...currentBasket];
		setBasket(getBasket);
	};

	const resetBasket = () => {
		setBasket([]);
	};

	const resetOrderForm = () => {
		setFormValues({});
	};

	const getOrg = () => {
		const urlParams = getUrlParams();
		const { orgID } = urlParams;
		if (orgID) {
			return orgID; // value to return
		}
		return null;
	};

	/**
	 * format the packages sent by the HTTP call from the database.
	 * Use this area to massage all data
	 * @param {Array} packages
	 * @return {Array} packages
	 */
	const formatPackages = (packages) => {
		return packages
			.map((item) => {
				// turn the packages conflicting string into an array
				const packagesConflictingArray = commaSeperatedToArray(item.packagesConflicting);

				// convert packages conflicting from productID to packageID e.g
				// "PK_EP_123" >>> 123
				const convertProductIDToPackageID = (productIDs) => {
					if (productIDs.length > 0) {
						return productIDs.map((packageItem) => {
							if (typeof packageItem === "string") {
								const startOfPackageID = packageItem.lastIndexOf("_") + 1;
								const packageID = packageItem.substring(startOfPackageID);
								return Number(packageID);
							} else {
								return packageItem;
							}
						});
					} else {
						return productIDs;
					}
				};

				item.packagesConflicting = convertProductIDToPackageID(packagesConflictingArray);
				item.productNameList = commaSeperatedToArray(item.productNameList);
				item.additionalUsers = 0;

				/*     
        this is needed to make sure that any packages that can be ordered in packs
        like optional tests they default to 0, if they get added to the basket they
        will always be a minimum of 1. For all other packages that just get clicked
        to order they will need to have a default value of 1. See the StoredPreceedure
        for more info */
				item.packageQuantity = !item.canOrderMultiple ? 1 : 0;

				// TODO: once this is called from the database remove this function
				item.requiresDataManager = (() => {
					const currentPackage = item.packageID;
					const dataManagerPackages = [
						183, 184, 197, 217, 218, 219, 234, 246, 247, 233, 249, 250, 251, 232,
					];
					return dataManagerPackages.includes(currentPackage);
				})();
				return item;
			})
			.filter(
				// if the site == TB then hide the transition maths and science packages
				(item) =>
					getBrand().brand === "TB" && (item.packageID === 3 || item.packageID === 5) ? null : item
			);
	};

	const doublestruckTheme = brand.theme;
	return (
		<BrowserRouter>
			<div className={doublestruckTheme} style={{ flexGrow: "1" }}>
				<PageHeader
					basket={basket}
					basketStatus={showBasket}
					navigationStage={navigationStage}
					brand={brand}
					handleShowBasket={handleShowBasket}
					handleShowSubject={handleShowSubject}
				/>
				<AlertMessage brand={brand.brand} show={false} />
				<Basket
					removePackageFromBasket={removePackageFromBasket}
					packages={basket}
					basketStatus={showBasket}
					updateBasket={updateBasket}
					brand={brand.brand}
					showBasket={showBasket}
					renewal={renewal}
					handleCloseBasket={handleCloseBasket}
					doublestruckTheme={doublestruckTheme}
					paperPackage={paperPackage}
				/>
				<HTTPRequest
					url={storedProcedure.getPackages.url}
					requestObject={getPackagesParams()}
					setPackages={setPackages}
				>
					{(allPackages) => (
						<Fragment>
							{/* <PrePopulateBasket
								// allPackages={() => formatPackages(allPackages)}
								allPackages={allLiveProducts}
								addMultipleItemsToBasket={addMultipleItemsToBasket}
								brand={brand.brand}
								basket={basket}
							/> */}
							<PrePopulateOrgDetails
								brand={brand.brand}
								orgID={getOrg()}
								updateFormValues={updateFormValues}
							/>
							<div style={{ padding: 0 }}>
								<Container fluid className="container__padtop">
									<Row>
										<Col xs={12}>
											<Routes>
												<Route
													exact
													path="/"
													element={
														<Catalog
															removePackageFromBasket={removePackageFromBasket}
															addToBasket={addToBasket}
															updateBasket={updateBasket}
															basket={basket}
															subjectMenuOpen={subjectMenuOpen}
															packages={packages}
															site={brand}
															showSubject={showSubject}
															handleCloseSubject={handleCloseSubject}
															updateMainState={() => {
																updateMainState(setPackages, packages);
															}}
														/>
													}
												/>
												<Route
													path="order-form"
													element={
														<OrderForm
															submitOrder={submitOrder}
															formValues={formValues}
															updateMainState={() => {
																updateMainState(setFormValues, formValues);
															}}
															basket={basket}
															orderSubtotal={orderSubTotal}
															orderTotal={orderTotal}
															resetBasket={resetBasket}
															handleShowBasket={handleShowBasket}
															resetresetOrderForm={resetOrderForm}
															MD5={MD5}
															setPromo_code={setPromo_code}
															brandName={brand.name}
															brand={brand.brand}
															renewal={renewal}
															showBasket={showBasket}
															freePackage={freePackage}
															paperPackage={paperPackage}
														/>
													}
												/>
												<Route
													path="/confirmation"
													element={
														<HTTPRequest
															url={storedProcedure.getPackages.url}
															requestObject={getPackagesParams()}
															setPackages={setPackages}
														>
															{(result) => {
																const packages = formatPackages(result);
																return (
																	<Confirmation
																		brand={brand}
																		packages={packages}
																		setPackages={setPackages}
																		paperPackage={paperPackage}
																	/>
																);
															}}
														</HTTPRequest>
													}
												/>
												<Route
													path="/dsdb-confirm-order"
													element={
														<HTTPRequest
															url={storedProcedure.getPackages.url}
															requestObject={getPackagesParams()}
															setPackages={setPackages}
														>
															{(result) => {
																const packages = formatPackages(result);
																return (
																	<ConfirmOrders
																		brand={brand}
																		packages={packages}
																		setPackages={setPackages}
																		paperPackage={paperPackage}
																	/>
																);
															}}
														</HTTPRequest>
													}
												/>
												<Route
													path="/secondary-maths-onscreen"
													element={
														<MathsSpecial
															packages={packages}
															addToBasket={addToBasket}
															basket={basket}
															removePackageFromBasket={removePackageFromBasket}
															site={site}
															freeMaths={freeMaths}
														/>
													}
												/>
												<Route
													path="/gcse-mfl-aqa"
													element={
														<LanguagesSpecial
															packages={packages}
															addToBasket={addToBasket}
															basket={basket}
															removePackageFromBasket={removePackageFromBasket}
															site={site}
														/>
													}
												/>
												<Route path="*" element={<Error404 />} />
											</Routes>
											<DoublestruckInternalTools brand={brand.brand} basket={basket} />
										</Col>
									</Row>
									<Row>
										<Col xs={12}>
											<Footer brand={brand.brand} freePackage={freePackage} />
										</Col>
									</Row>
								</Container>
							</div>
						</Fragment>
					)}
				</HTTPRequest>
			</div>
		</BrowserRouter>
	);
};

export default App;
